import { LOADING_DEFAULT_COLOR, LOADING_INACTIVE_COLOR } from 'HubStyleTokens/theme';
import { Component } from 'react';
import styled, { keyframes } from 'styled-components';
import ThemeContext from '../theming/contexts/ThemeContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const typingColorAnimation = keyframes(["25%{background-color:", ";}75%{background-color:", ";}"], LOADING_INACTIVE_COLOR, LOADING_INACTIVE_COLOR);
const typingAnimation = keyframes(["0%,100%{transform:translateY(0);}25%{transform:translateY(.25em);}50%{transform:translateY(0);}75%{transform:translateY(-.25em);}"]);
export const Dot = styled.div.withConfig({
  displayName: "TypingDots__Dot",
  componentId: "sc-1wpl156-0"
})(["position:relative;background-color:currentColor;color:", ";border-radius:50%;height:1em;width:1em;animation:", ",", ";animation-duration:1s;animation-timing-function:linear;animation-iteration-count:infinite;&:not(:last-child){margin-right:0.75em;}&:nth-child(2){animation-delay:-0.66s;}&:nth-child(3){animation-delay:-0.33s;}"], props => props.color ? props.color : LOADING_DEFAULT_COLOR, typingAnimation, typingColorAnimation);
export const TypingDotsWrapper = styled.div.withConfig({
  displayName: "TypingDots__TypingDotsWrapper",
  componentId: "sc-1wpl156-1"
})(["display:flex;align-items:center;justify-content:center;height:24px;font-size:8px;width:4.5em;"]);
class TypingDots extends Component {
  render() {
    const {
      widgetAccent
    } = this.context;
    return /*#__PURE__*/_jsxs(TypingDotsWrapper, {
      "data-test-id": "typing-dots",
      children: [/*#__PURE__*/_jsx(Dot, {
        color: widgetAccent,
        className: "dot-1"
      }), /*#__PURE__*/_jsx(Dot, {
        color: widgetAccent,
        className: "dot-2"
      }), /*#__PURE__*/_jsx(Dot, {
        color: widgetAccent,
        className: "dot-3"
      })]
    });
  }
}
TypingDots.displayName = 'TypingDots';
TypingDots.contextType = ThemeContext;
export default TypingDots;